import axios from "axios"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../utils/storage"

export const getConfigurationApi = () => {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/configuration`,
  })
}

export const putConfigurationApi = (data = {}) => {
  return axios.request({
    method: "PUT",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/configuration`,
    data,
  })
}

export const listGenders = () => {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}genders`,
  })
}

export const createUser = (data = {}) => {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${
      data.company_id ? data.company_id : LOCAL_COMPANY_ID()
    }/users`,
    data,
  })
}

export const updateUser = (data = {}, idUser) => {
  return axios.request({
    method: "PUT",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}users/${idUser}`,
    data,
  })
}

export const updateSwitchUser = ({ idUser, is_superadmin, company_id }) => {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${company_id ||
      LOCAL_COMPANY_ID()}/users/${idUser}/toggle-superadmin`,
    data: { is_superadmin },
  })
}


